import {FComponent} from "./f-component";
import {createElement as h} from "react";

interface S {
}
interface P {
    props?;
    action;
    skippable?: boolean;
    time;
    // next;
}

export const TimedAction = ({props=undefined, action, skippable=false, time}) => h(TimedAction1, {props, action, skippable, time});

class TimedAction1 extends FComponent<P, S> {
    clear;

    constructor(props, context) {
        super(props, context);

        this.onMount(() => {
            this.setupTimeout();
            this.onUnmount(() => {
                this.clear && this.clear();
            });
        });
    }

    setupTimeout() {
        this.clear && this.clear();
        this.clear = null;

        let delay = this.props.time - Date.now();
        // console.log(`Action: delay ${delay / (60*60*1000)}`);
        if (delay < 0) {
            if (!this.props.skippable) {
                delay = 0;
            }
        }

        if (delay < 0) {
            return;
        }

        const timeout = setTimeout(() => {
            this.clear = null;

            this.props.action({
                getLatestProps: () => this.props.props,
            });
        }, delay);
        this.clear = () => clearTimeout(timeout);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.time !== this.props.time) {
            this.setupTimeout();
        }
    }
    render() {
        return null;
    }
}
